import { render, staticRenderFns } from "./StartupCostsTimeline.vue?vue&type=template&id=23b348d3"
import script from "./StartupCostsTimeline.vue?vue&type=script&lang=js"
export * from "./StartupCostsTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports